/**
 * Determines the MIME type based on the file name extension.
 * @param name - The file name or path
 * @returns The MIME type string for use in data URLs
 */
export const getMimeTypeFromName = (name?: string): string => {
    if (!name) return "image";

    const extension = name.toLowerCase().split(".").pop();

    switch (extension) {
        case "svg":
            return "image/svg+xml";
        case "png":
            return "image/png";
        case "jpg":
        case "jpeg":
            return "image/jpeg";
        case "gif":
            return "image/gif";
        case "webp":
            return "image/webp";
        case "bmp":
            return "image/bmp";
        default:
            return "image";
    }
};
